import NiceModal from "@ebay/nice-modal-react";
import type { GullakCashDrawerProps } from ".";
import RuleDetail, { type RuleDetailProps } from "./components/rule-detail";
import HistoryStatistic from "./components/history-statistic";
import LazyGullakCashDrawer from './';

export function showGullakCashDrawer(props: GullakCashDrawerProps) {
  return NiceModal.show(LazyGullakCashDrawer, props);
}

export function hideGullakCashDrawer() {
  return NiceModal.hide(LazyGullakCashDrawer);
}

export function showHistoryStatisticDrawer() {
  return NiceModal.show(HistoryStatistic);
}

export function showRuleDrawer(params: RuleDetailProps) {
  return NiceModal.show(RuleDetail, params);
}